<template>
    <div class="expandable">
        <span @click.stop="collapse()">{{expandableText()}}</span>
        <span v-if="!isExpanded">
            <span>...</span>
            <a href="#" @click.prevent.stop="expand($event)">Read more</a>
        </span>
    </div>
</template>

<script>
  export default {
    data() {
        return {
            expanded: false,
            maxWords: 30
        };
    },
    props: {
      text: ''
    },
    methods: {
        expandableText() {
            if (this.isExpanded) {
                return this.text;
            } else {
                return this.textParts.slice(0, this.maxWords).join(' ');
            }
        },
        collapse() {
            this.expanded = false;
            return false;
        },
        expand() {
            this.expanded = true;
            return false;
        },
    },
    computed: {
        isExpanded() {
            return this.expanded === true || !this.isMaxWords;
        },
        isMaxWords() {
            return this.textParts.length > this.maxWords;
        },
        textParts() {
            return this.text ? this.text.split(' ') : [];
        }
    }
  }
</script>

<style>
.expandable .readmore {
    padding-left:5px;
}
.expandable .readmore span {
    cursor: pointer;
    border-radius: 5px;
    background: #eee;
    font-size:16px;
    line-height:5px;
    padding-bottom:5px;
    padding-left:2px;
    padding-right:2px;
    display:inline-block;
}
</style>
